<template>
  <div class="campus-tab-container">
    <div
      class="tab-item"
      v-for="(item, index) in tabList"
      :key="index"
      :class="{ active: index === activeIndex }"
      @click="clickTab(index)"
    >
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "BlockCampusTab",
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    clickTab(index) {
      this.$emit("clickTab", index);
    },
  },
};
</script>
<style lang="scss" scoped>
.campus-tab-container {
  display: flex;
  height: 53px;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #e5e6eb;
  .tab-item {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 32px;
    cursor: pointer;
    color: #1d2129;
    font-size: 16px;
    font-weight: 400;
    &.active {
      color: #f64;
      font-weight: 500;
      &::after {
        content: "";
        display: inline-block;
        width: 28px;
        height: 2px;
        background-color: #f64;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
      }
    }
  }
}
</style>
